module.exports = __webpack_public_path__ + "static/img/img_shaangu.7454366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/img_shaangu.jpg
// module id = /Pvd
// module chunks = 0